module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b41fa406852eb07c7fb079b0ebec804c.png";